import axios from 'axios';

import auth from "@/store/authentication.js";

const user_role = auth.state.user_role;

export default {
  findAll(ctx) {
    return axios.get(api_url + user_role + "/packs", {
      params: {ctx: ctx}
    });
  },
  getFields() {
    return axios.get(api_url + user_role + "/packs/fields");
  },
  find(id) {
    return axios.get(api_url + user_role + "/packs/" + id);
  },
  findSku(sku) {
    return axios.get(api_url + user_role + "/packs/sku/" + sku);
  },
  findAkeneo(id) {
    return axios.get(api_url + user_role + "/packs/get-pack-akeneo/" + id);
  },
  create(params) {
    return axios.post(api_url + user_role + "/packs", params);
  },
  update(params) {
    return axios.post(api_url + user_role + "/packs/" + params.id, params);
  },
  actualizar() {
    return axios.get(api_url + user_role + "/packs/actualizar");
  },
  updatePoints(params) {
    return axios.post(api_url + user_role + "/packs/" + params.id + "/update-points", params.pack_breakdown_customized_json);
  },
  delete(id) {
    return axios.delete(api_url + user_role + "/packs/" + id);
  },
  triggerMassiveZipImport() {
    return axios.post(api_url + user_role + "/packs/import-zips");
  }
}



// WEBPACK FOOTER //
// ./src/api/pack.js